
import { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { IoIosSave } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;
`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;


const Input1 = styled.input`

  width: 200px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;


const Input2 = styled.input`
  width: auto;
  min-width: 500px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;
const Input3 = styled.input`
  width: 70px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;

const Input4 = styled.input`
  width: auto;
  min-width: 500px;
  height: 200px;
  padding: 0 10px; 
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 
`;
const H2 = styled.h2`
  color: #575757;
`;

const Button = styled.button`
  padding: 10px 30px;
  background-color: transparent;
  color: #575757;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
  
`;


const Form = ({ urlApi, tipoMaterial, subTipoMaterial, setAtualizaMateriais, editarMateriais }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (editarMateriais) {
      setCodigoMaterial(editarMateriais.COD_MATERIAL.toString()); // importante: campo é string
      setDescricaoMaterial({
        DESC_MATERIAL: editarMateriais.DESCRICAO,
        UNIDADE_MEDIDA: editarMateriais.UNIDADE_MEDIDA || ''
      });
      setTipoSelecionado(editarMateriais.TIPO);
      setSubtipoSelecionado(editarMateriais.SUBTIPO);
      setObservacao(editarMateriais.OBSERVACAO || '');
    }
  }, [editarMateriais]);


  //========================================================SELECT FILTRA O OUTRO
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [subtipoSelecionado, setSubtipoSelecionado] = useState(null);

  // Filtra os subtipos com base no tipo selecionado
  const subtiposFiltrados = subTipoMaterial.filter(
    (sub) => sub.COD_TIPO === tipoSelecionado
  );

  const [codigoMaterial, setCodigoMaterial] = useState('');
  const [descricaoMaterial, setDescricaoMaterial] = useState('');







  //========================================================ADICIONAR O MATERIAL NO LB_MATERIAL
  const [observacao, setObservacao] = useState('');

  const handleEditaMaterial = async () => {
    if (observacao && observacao.length > 250) {
      toast.warn('A observação não pode ter mais de 250 caracteres.');
      return;
    }

    try {
      const payload = {
        tipo: tipoSelecionado,
        subtipo: subtipoSelecionado,
        observacao: observacao?.trim() || null,
      };

      const res = await axios.put(
        `${urlApi}controle-reagentes/alterar-material/${codigoMaterial.trim()}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success(res.data.message || 'Material atualizado com sucesso!');
      setAtualizaMateriais(true);
    } catch (err) {
      console.error('Erro ao atualizar material:', err);
      toast.error(err.response?.data?.error || 'Erro ao atualizar material.');
    }
  };




  return (
    <DivGeral>
      <H2>Editar Material</H2>

      <Div >
        {/* Select de Tipo */}
        <Label>
          Tipo de Material:
          <select
            value={tipoSelecionado || ''}
            onChange={(e) => {
              const valor = parseInt(e.target.value, 10);
              setTipoSelecionado(valor);
              setSubtipoSelecionado(null); // limpa o subtipo ao trocar o tipo
            }}
          >
            <option value="" disabled>Selecione o tipo</option>
            {tipoMaterial.map((tipo) => (
              <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
                {tipo.DESC_TIPO}
              </option>
            ))}
          </select>
        </Label>

        {/* Select de Subtipo (dependente) */}
        <Label >
          Subtipo:
          <select
            value={subtipoSelecionado || ''}
            onChange={(e) => setSubtipoSelecionado(parseInt(e.target.value, 10))}
            disabled={!tipoSelecionado}
          >
            <option value="" disabled>Selecione o subtipo</option>
            {subtiposFiltrados.map((sub) => (
              <option key={sub.COD_SUBTIPO} value={sub.COD_SUBTIPO}>
                {sub.DESC_SUBTIPO}
              </option>
            ))}
          </select>
        </Label>
      </Div>
      <Div>
        <Label>
          Código do Material:
          <Input1
            type="text"
            value={codigoMaterial}
            onChange={(e) => setCodigoMaterial(e.target.value)}
            disabled
            placeholder="Digite o código"
          />

        </Label>

        {/* Exibe a descrição do material */}
        <Label>
          Descrição:
          <Input2
            type="text"
            value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
            disabled
          />

        </Label>
        <Label>
          Uni:
          <Input3
            type="text"
            value={` ${descricaoMaterial.UNIDADE_MEDIDA || ''}`}
            disabled

          />

        </Label>
      </Div>
      <Div>
        <Label>
          Observação:
          <Input4
            type="text"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            maxLength={250}
            disabled={!codigoMaterial}
            placeholder="Digite uma observação"
          />


        </Label>
      </Div>
      <Div>
        <Button
          disabled={!codigoMaterial || !tipoSelecionado || !subtipoSelecionado}
          onClick={handleEditaMaterial}
        >
          <IoIosSave color={"green"} />Salvar Alteração
        </Button>
      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




